module.exports = __webpack_public_path__ + "static/media/3.c6744e72.jpg";